import { useState } from 'react';
import { Link, useParams, Navigate } from 'react-router-dom';
import { Play } from 'lucide-react';
import PhotoPlaceholder from '../components/photo-placeholder';
import { CATS, TRAT } from '../data/services';
import { BUSINESS, telLink } from '../lib/business';
import { buildWhatsappUrl } from '../lib/whatsapp';

const FaqItem = ({ p, r, open, onToggle }) => (
  <div style={{ borderBottom: '1px solid var(--ink-200)' }}>
    <button
      onClick={onToggle}
      style={{
        width: '100%',
        background: 'none',
        border: 0,
        cursor: 'pointer',
        textAlign: 'left',
        padding: '18px 0',
        display: 'flex',
        gap: 16,
        alignItems: 'center',
        justifyContent: 'space-between',
        fontFamily: 'inherit',
        fontSize: 15.5,
        color: 'var(--ink-800)',
      }}
    >
      {p}
      <span style={{ color: 'var(--rose-600)', fontSize: 20, lineHeight: 1, flex: 'none' }}>{open ? '−' : '+'}</span>
    </button>
    {open && (
      <p style={{ fontSize: 14.5, lineHeight: 1.7, color: 'var(--ink-600)', margin: '0 0 20px', maxWidth: '60ch' }}>
        {r}
      </p>
    )}
  </div>
);

const TreatmentDetail = () => {
  const { cat: catId, id } = useParams();
  const [openFaq, setOpenFaq] = useState(0);
  const cat = CATS.find((c) => c.id === catId);
  const trat = (TRAT[catId] ?? []).find((t) => t.id === id);

  if (!cat || !trat) return <Navigate to="/servicios" replace />;

  const waMsg = buildWhatsappUrl(BUSINESS.whatsapp, `Hola Zenya, me interesa ${trat.nombre}. ¿Tienen disponibilidad?`);

  return (
    <div>
      <section style={{ background: '#FFF', borderBottom: '1px solid var(--ink-100)', padding: '4vw 5vw 5vw' }}>
        <div style={{ maxWidth: 1100, margin: '0 auto' }}>
          <Link
            to={`/servicios/${cat.id}`}
            style={{ fontSize: 12, letterSpacing: '.14em', textTransform: 'uppercase', color: 'var(--ink-500)' }}
          >
            ← {cat.nombre}
          </Link>
          <h1
            style={{
              fontFamily: 'var(--font-display)',
              fontWeight: 300,
              fontSize: 'clamp(34px, 5.6vw, 60px)',
              lineHeight: 1.06,
              color: 'var(--ink-900)',
              margin: '18px 0 16px',
              maxWidth: '20ch',
            }}
          >
            {trat.nombre}
          </h1>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, marginBottom: 20 }}>
            <span
              style={{
                fontSize: 11.5,
                letterSpacing: '.12em',
                textTransform: 'uppercase',
                color: 'var(--ink-600)',
                background: 'var(--ink-50)',
                border: '1px solid var(--ink-200)',
                borderRadius: 'var(--radius-pill)',
                padding: '6px 14px',
              }}
            >
              {trat.duracion}
            </span>
            <span
              style={{
                fontSize: 11.5,
                letterSpacing: '.12em',
                textTransform: 'uppercase',
                color: 'var(--rose-700)',
                background: 'var(--rose-50)',
                border: '1px solid var(--rose-200)',
                borderRadius: 'var(--radius-pill)',
                padding: '6px 14px',
              }}
            >
              {trat.precio}
            </span>
            <span
              style={{
                fontSize: 11.5,
                letterSpacing: '.12em',
                textTransform: 'uppercase',
                color: 'var(--lavender-700)',
                background: 'var(--lavender-50)',
                border: '1px solid var(--lavender-200)',
                borderRadius: 'var(--radius-pill)',
                padding: '6px 14px',
              }}
            >
              {trat.etiqueta}
            </span>
          </div>
          <p
            style={{
              fontSize: 'clamp(16px, 1.8vw, 19px)',
              lineHeight: 1.75,
              color: 'var(--ink-700)',
              maxWidth: '62ch',
              margin: 0,
            }}
          >
            {trat.descripcion}
          </p>
        </div>
      </section>

      <section style={{ padding: '5vw 5vw 0', maxWidth: 1100, margin: '0 auto' }}>
        <div
          style={{
            aspectRatio: '16/9',
            background: 'var(--ink-900)',
            borderRadius: 'var(--radius-xl)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 14,
            color: 'var(--rose-200)',
          }}
        >
          <div
            style={{
              width: 64,
              height: 64,
              borderRadius: '50%',
              border: '1px solid var(--rose-300)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Play size={22} fill="currentColor" />
          </div>
          <span style={{ fontSize: 10, letterSpacing: '.22em', textTransform: 'uppercase', color: 'var(--rose-300)' }}>
            Video · placeholder
          </span>
          <span style={{ fontSize: 13.5, color: 'var(--rose-100)', textAlign: 'center', padding: '0 20px' }}>
            {trat.video}
          </span>
        </div>
      </section>

      <section
        className="z-detail-grid"
        style={{
          padding: '5vw',
          maxWidth: 1100,
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: '1fr',
          gap: '4vw',
          alignItems: 'start',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '3vw' }}>
          <div>
            <h2
              style={{
                fontFamily: 'var(--font-display)',
                fontWeight: 400,
                fontSize: 30,
                color: 'var(--ink-900)',
                margin: '0 0 16px',
              }}
            >
              Beneficios
            </h2>
            <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 12 }}>
              {trat.beneficios.map((b) => (
                <li
                  key={b}
                  style={{
                    display: 'flex',
                    gap: 12,
                    alignItems: 'flex-start',
                    fontSize: 15,
                    lineHeight: 1.65,
                    color: 'var(--ink-700)',
                  }}
                >
                  <span
                    style={{
                      width: 6,
                      height: 6,
                      borderRadius: '50%',
                      background: 'var(--rose-500)',
                      marginTop: 9,
                      flex: 'none',
                    }}
                  />
                  {b}
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h2
              style={{
                fontFamily: 'var(--font-display)',
                fontWeight: 400,
                fontSize: 30,
                color: 'var(--ink-900)',
                margin: '0 0 16px',
              }}
            >
              Procedimiento
            </h2>
            <ol style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: 14 }}>
              {trat.procedimiento.map((texto, i) => (
                <li key={texto} style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
                  <span
                    style={{
                      fontFamily: 'var(--font-display)',
                      fontSize: 20,
                      color: 'var(--rose-500)',
                      lineHeight: 1.3,
                      minWidth: 22,
                    }}
                  >
                    0{i + 1}
                  </span>
                  <span style={{ fontSize: 15, lineHeight: 1.65, color: 'var(--ink-700)' }}>{texto}</span>
                </li>
              ))}
            </ol>
          </div>
          <div>
            <h2
              style={{
                fontFamily: 'var(--font-display)',
                fontWeight: 400,
                fontSize: 30,
                color: 'var(--ink-900)',
                margin: '0 0 16px',
              }}
            >
              Fotografías
            </h2>
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 150px), 1fr))',
                gap: 12,
              }}
            >
              {trat.fotos.map((f) => (
                <PhotoPlaceholder key={f} label={f} />
              ))}
            </div>
          </div>
          <div>
            <h2
              style={{
                fontFamily: 'var(--font-display)',
                fontWeight: 400,
                fontSize: 30,
                color: 'var(--ink-900)',
                margin: '0 0 16px',
              }}
            >
              Preguntas frecuentes
            </h2>
            <div style={{ borderTop: '1px solid var(--ink-200)' }}>
              {trat.faq.map((q, i) => (
                <FaqItem
                  key={q.p}
                  p={q.p}
                  r={q.r}
                  open={openFaq === i}
                  onToggle={() => setOpenFaq((cur) => (cur === i ? -1 : i))}
                />
              ))}
            </div>
          </div>
        </div>

        <aside
          style={{
            position: 'sticky',
            top: 92,
            background: '#FFF',
            border: '1px solid var(--ink-200)',
            borderRadius: 'var(--radius-xl)',
            boxShadow: 'var(--shadow-md)',
            padding: 26,
            display: 'flex',
            flexDirection: 'column',
            gap: 14,
          }}
        >
          <span style={{ fontSize: 10.5, letterSpacing: '.2em', textTransform: 'uppercase', color: 'var(--rose-600)' }}>
            Ideal para
          </span>
          <p style={{ fontSize: 14.5, lineHeight: 1.7, color: 'var(--ink-700)', margin: 0 }}>{trat.ideal}</p>
          <div style={{ height: 1, background: 'var(--ink-100)', margin: '4px 0' }} />
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
            <span style={{ fontSize: 13, color: 'var(--ink-600)' }}>Duración</span>
            <span style={{ fontSize: 14, color: 'var(--ink-800)' }}>{trat.duracion}</span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
            <span style={{ fontSize: 13, color: 'var(--ink-600)' }}>Costo</span>
            <span style={{ fontFamily: 'var(--font-display)', fontSize: 30, color: 'var(--rose-700)', lineHeight: 1 }}>
              {trat.precio}
            </span>
          </div>
          <Link
            to="/agendar"
            style={{
              textAlign: 'center',
              background: 'var(--rose-700)',
              color: '#FFF',
              fontSize: 13.5,
              letterSpacing: '.06em',
              padding: 14,
              borderRadius: 'var(--radius-pill)',
              marginTop: 6,
            }}
          >
            Agendar cita
          </Link>
          <a
            href={waMsg}
            target="_blank"
            rel="noreferrer"
            style={{
              textAlign: 'center',
              border: '1px solid var(--rose-300)',
              color: 'var(--rose-700)',
              fontSize: 13.5,
              letterSpacing: '.06em',
              padding: 14,
              borderRadius: 'var(--radius-pill)',
            }}
          >
            Preguntar por WhatsApp
          </a>
          <a
            href={telLink}
            style={{
              textAlign: 'center',
              border: '1px solid var(--ink-200)',
              color: 'var(--ink-700)',
              fontSize: 13.5,
              letterSpacing: '.06em',
              padding: 14,
              borderRadius: 'var(--radius-pill)',
            }}
          >
            Llamar
          </a>
          <span style={{ fontSize: 12, lineHeight: 1.5, color: 'var(--ink-500)', textAlign: 'center' }}>
            Elige día y hora en línea. Si tienes dudas antes de reservar, escríbenos.
          </span>
        </aside>
      </section>
    </div>
  );
};

export default TreatmentDetail;
